module.exports = __webpack_public_path__ + "static/img/calendar-saving.d7a7a75c.svg";